import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

import classes from "./AutomationsGrid.module.css";
import Card from './Card';
import LockContentLayout from '../UI/Cards/Automations/VirutalSources/SmartLocks/LockContentLayout';
import CreateAutomation from '../UI/Cards/Automations/EditAutomations/CreateAutomation';
import CreateVirtualSource from '../UI/Cards/Automations/VirutalSources/CreateVirtualSource';
import CametContentLayout from '../UI/Cards/Automations/VirutalSources/Camect/CametContentLayout';
import SigFoxContentLayout from '../UI/Cards/Automations/VirutalSources/Sigfox/SigFoxContentLayout';
import EfentoContentLayout from '../UI/Cards/Automations/VirutalSources/Efento/EfentoContentLayout';
import GatewayContentLayout from '../UI/Cards/Automations/VirutalSources/Gateway/GatewayContentLayout';
import { clearDeviceLogs } from '../../Api Methods/Api';
import DavantisContentLayout from '../UI/Cards/Automations/VirutalSources/Davantis/DavantisContentLayout';
import IntegrationContentLayout from '../UI/Cards/Automations/VirutalSources/Integrations/IntegrationContentLayout';
import LiveViewContentLayout from '../UI/Cards/Automations/VirutalSources/LiveView/LiveViewContentLayout';
import IntegrationCard from '../UI/Cards/Devices/IntegrationCard';
import SigfoxCard from '../UI/Cards/Devices/SigfoxCard';
import EfentoCard from '../UI/Cards/Devices/EfentoCard';
import GatewayCard from '../UI/Cards/Devices/GatewayCard';
import IglooCard from '../UI/Cards/Devices/IglooCard';
import LiveViewCameraCard from '../UI/Cards/Devices/LiveViewCameraCard';
import TeltonikaCard from '../UI/Cards/Devices/TeltonikaCard';
import TankSensorCard from '../UI/Cards/Devices/TankSensorCard';

const VirtualSourcesGrid = ({ 
    Camects, 
    davantis, 
    outputs, 
    inputs, 
    iglooLocks, 
    fetchVirtualSources, 
    HandleSelectCamectModalForm, 
    setShowVirtualSource, 
    firmware, 
    sigfoxSensors, 
    efentoSensors, 
    teltonikaSensors, 
    tankSensors,
    gateways, 
    camectIntegrationType, 
    setHasDeviceChanged, 
    supportsCamect, 
    integrations, 
    siteType, 
    supportsLiveView, 
    liveViewCameras, 
    successVisible, 
    setSuccessVisible, 
    apiData, 
    siteUUID 
}) => {
    let camectLength = 0;
    let davantisLength = 0;
    let iglooLocksLength = 0;
    let sigfoxSensorsLength = 0;
    let efentoSensorsLength = 0;
    let teltonikaSensorsLength = 0;
    let tankSensorLength = 0;
    let gatewaysLength = 0;
    let integrationsLength = 0
    let liveViewCamerasLength = 0

    const role = useSelector(state => state.auth.role);
    const Firmware = firmware.split('.')
    const firmwareMajor = Firmware[0]
    const firmwareMinor = Firmware[1]
    const numInput = inputs.length

    if (Camects !== null) {
        camectLength = Camects.length;
    }

    if (davantis != null && davantis[0] != null && davantis[0].davantises != null) {
        davantisLength = davantis[0].davantises.length;
    }

    if (iglooLocks !== null && iglooLocks !== undefined) {
        iglooLocksLength = iglooLocks.length;
    }

    if (sigfoxSensors !== null) {
        sigfoxSensorsLength = sigfoxSensors.length;
    }

    if (efentoSensors !== null) {
        efentoSensorsLength = efentoSensors.length;
    }
    
    if (teltonikaSensors !== null) {
        teltonikaSensorsLength = teltonikaSensors.length;
    }

    if (tankSensors !== null) {
        tankSensorLength = tankSensors.length;
    }

    if (gateways !== null) {
        gatewaysLength = gateways.length;
    }

    if (integrations !== null) {
        integrationsLength = integrations.length;
    }

    if (liveViewCameras !== null) {
        liveViewCamerasLength = liveViewCameras.length;
    }

    const NumberOfItemsInVirutalSourcesArray = camectLength;
    const gridStyleConditional = NumberOfItemsInVirutalSourcesArray < 4 && "flex"

    return (
        <>

            <div className={classes.deviceGrid}>

                {(role === "admin" || role === "TechSupport") && (
                    <Card>
                        <CreateVirtualSource
                            HandleSelectCamectModalForm={HandleSelectCamectModalForm}
                            numInput={numInput}
                            firmwareMajor={firmwareMajor}
                            firmwareMinor={firmwareMinor}
                            supportsCamect={supportsCamect}
                            siteType={siteType}
                            supportsLiveView={supportsLiveView}
                        />
                    </Card>
                )}

                {iglooLocks && iglooLocks.map((lock, index) => {
                    const pin = outputs.filter(Pin => Pin.Pin == lock.outputPin);

                    return (
                        <IglooCard device={lock} pinObject={pin} showSuccess={setSuccessVisible} apiData={apiData} siteUUID={siteUUID} refreshDevices={fetchVirtualSources} iglooLocks={iglooLocks}/>
                    )
                })}

                {Camects[0].camects !== null && Camects[0].camects.map((camect, index) => {

                    // filter out Pulse Outputs
                    const Outputs = outputs.filter((OutPut, index) => OutPut.type == 'LATCH' || OutPut.type == 'VIRTUAL_LATCH');

                    // Filter out output pins with assigned smartlocks
                    const LatchOutputs = Outputs.filter(output => {
                        return iglooLocks.every(lock => !lock || lock.outputPin != output.Pin);
                    });

                    let allPins;

                    if (firmwareMajor == '1' && firmwareMinor >= '9' || firmwareMajor > 1) {
                        // adding outputs and inputs into one array
                        allPins = [...LatchOutputs, ...inputs];
                    } else {
                        allPins = LatchOutputs;
                    }

                    const relationshipKeys = Object.keys(Camects[0].relationships);
                    let LinkedPins = [];

                    relationshipKeys.forEach((key) => {
                        if (Camects[0].relationships[key].startsWith(camect.id)) {
                            const outputMatch = allPins.filter(output => output.Pin == key);
                            // Assuming rest is already defined as an array and camect is an object with an id property

                            LinkedPins = [...LinkedPins, ...outputMatch];
                        }
                    });


                    // Filter out Linked pins
                    const availablePins = allPins.filter(Pin => {
                        if (camectIntegrationType != 2) {
                            return LinkedPins.every(LinkedPin => LinkedPin != Pin);
                        } else {
                            //Dont remove already linked pins, as you need to be able to deselct cams
                            return LinkedPins
                        }

                    });

                    return (
                        <CametContentLayout camect={camect} LinkedPins={LinkedPins} fetchVirtualSources={fetchVirtualSources} HandleSelectCamectModalForm={HandleSelectCamectModalForm} Outputs={availablePins}/>
                    )
                })}

                {davantisLength > 0 && davantis[0].davantises !== null && davantis[0].relationships !== null && davantis[0].davantises.map((Davantis, index) => {

                    // filter out Pulse Outputs
                    const Outputs = outputs.filter((OutPut, index) => OutPut.type == 'LATCH' || OutPut.type == 'VIRTUAL_LATCH');

                    // Filter out output pins with assigned smartlocks
                    const LatchOutputs = Outputs.filter(output => {
                        return iglooLocks.every(lock => !lock || lock.outputPin != output.Pin);
                    });

                    let allPins;

                    if (firmwareMajor == '1' && firmwareMinor >= '9' || firmwareMajor > 1) {
                        // adding outputs and inputs into one array
                        allPins = [...LatchOutputs, ...inputs];
                    } else {
                        allPins = LatchOutputs;
                    }
                    const relationshipKeys = Object.keys(davantis[0].relationships);
                    let LinkedPins = [];

                    relationshipKeys.forEach((key) => {
                        if (davantis[0].relationships[key].startsWith(Davantis.id)) {
                            const outputMatch = allPins.filter(output => output.Pin == key);
                            // Assuming rest is already defined as an array and camect is an object with an id property

                            LinkedPins = [...LinkedPins, ...outputMatch];
                        }
                    });


                    // Filter out Linked pins
                    const availablePins = allPins.filter(Pin => {
                        return LinkedPins.every(LinkedPin => LinkedPin != Pin);
                    });

                    return (
                        <DavantisContentLayout davantis={Davantis} LinkedPins={LinkedPins} fetchVirtualSources={fetchVirtualSources} HandleSelectCamectModalForm={HandleSelectCamectModalForm} Outputs={availablePins}/>
                    )
                })}

                {integrations && integrations?.length > 0 && integrations?.map((integration, index) => {
                    const pin = outputs.find(Pin => Pin.Pin == parseInt(integration.pin))
                    return (
                        <IntegrationCard integration={integration} pinObject={pin} apiData={apiData} siteUUID={siteUUID} showSuccess={setSuccessVisible} refreshDevices={fetchVirtualSources} />
                    )
                })}

                {sigfoxSensors.length > 0 && sigfoxSensors.map((sensor, index) => {
                    const pin = inputs.find(Pin => Pin.Pin == parseInt(sensor.virtualInput))
                    return (
                        <SigfoxCard sensor={sensor} pinObject={pin} apiData={apiData} siteUUID={siteUUID} showSuccess={setSuccessVisible} refreshDevices={fetchVirtualSources}/>
                    )
                })}

                {efentoSensors.length > 0 && efentoSensors.map((sensor, index) => {
                    const pin = inputs.find(Pin => Pin.Pin == parseInt(sensor.virtualInput))
                    return (
                        <EfentoCard efento={sensor} pinObject={pin} apiData={apiData} siteUUID={siteUUID} showSuccess={setSuccessVisible} refreshDevices={fetchVirtualSources}/>
                    )
                })}

                {teltonikaSensors.length > 0 && teltonikaSensors.map((sensor, index) => {
                    const pin = inputs.find(Pin => Pin.Pin == parseInt(sensor.virtualInput))
                    return (
                        <TeltonikaCard teltonika={sensor} pinObject={pin} apiData={apiData} siteUUID={siteUUID} showSuccess={setSuccessVisible} refreshDevices={fetchVirtualSources}/>
                    )
                })}

                {tankSensorLength> 0 && tankSensors.map((sensor, index) => {
                    const pin = inputs.find(Pin => Pin.Pin == parseInt(sensor.virtualInput))
                    return (
                        <TankSensorCard tankSensor={sensor} pinObject={pin} apiData={apiData} siteUUID={siteUUID} showSuccess={setSuccessVisible} refreshDevices={fetchVirtualSources}/>
                    )
                })}

                {gateways.length > 0 && gateways.map((gateway, index) => {
                    return (
                        <GatewayCard gateway={gateway} showSuccess={setSuccessVisible} apiData={apiData} siteUUID={siteUUID} refreshDevices={fetchVirtualSources}/>
                    )
                })}

                {liveViewCamerasLength > 0 && liveViewCameras.map((camera, index) => {
                    return (
                        <LiveViewCameraCard camera={camera} showSuccess={setSuccessVisible} apiData={apiData} siteUUID={siteUUID} refreshDevices={fetchVirtualSources}/>
                    )
                })}
            </div>
        </>
    )
}

export default VirtualSourcesGrid